module.exports = {
  webapi: process.env.REACT_APP_WEBAPI_URL || 'http://localhost:3000'
};
